import { INiche } from "@/common/services/types";
import { Image } from "@/components";

import "./NicheSelector.scss";
import { useCallback, useMemo } from "react";
import { getFilteredNiches, updateSelectedNiches } from "./utils";
import { Checkbox } from "@/components/inputs/Checkbox";

interface IProps {
  niches: INiche[];
  selected: string[];
  onChange: (values: string[]) => void;
}

export const NicheSelector = ({ niches, selected, onChange }: IProps): JSX.Element => {
  const orderedNiches = useMemo(
    () => getFilteredNiches(niches, selected),
    [niches, selected]
  );

  const handleCheckBoxChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(updateSelectedNiches(event.target.name, selected));
  }, [onChange, selected]);

  return (
    <div className="nicheSelector">
      {orderedNiches.map((el: INiche) => (
        <div className="row" key={el.id}>
          <Image className={"thumbnail"} src={el.thumbnail} />

          <div className="name">{el.name}</div>

          <Checkbox
            name={el.id}
            onChange={handleCheckBoxChange}
            checked={selected.indexOf(el.id) >= 0}
          />
        </div>
      ))}
    </div>
  );
};
